import React from "react";
import { useEffect } from "react";
import Pinjam from "../../components/Pinjam/DaftarPinjam";

const Peminjaman = () => {
  useEffect(() => {
    document.title = "Si TASIK - Peminjaman";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <Pinjam/>
    </div>
  );
};

export default Peminjaman;
